import axios from 'axios'
import { store } from 'store'

import { AuthStorage } from 'services/storage/AuthStorage'

const clientApi = axios.create({
  baseURL: process.env.BASE_URL || '/api/',
  withCredentials: true,
})

clientApi.interceptors.request.use(
  config => {
    const token = AuthStorage.getAccessToken()

    if (token) {
      config.headers!.Authorization = `Token ${token}`
    }

    return config
  },
  error => Promise.reject(error),
)

clientApi.interceptors.response.use(
  response => {
    return Promise.resolve(response)
  },
  error => {
    const response = error?.response
    const method = response?.config?.method

    const requestUrl = error.config?.url || error.response?.config?.url
    if (requestUrl.includes('auth/me/systems')) {
      return
    }
    if (['get', 'post', 'put', 'delete', 'patch'].includes(method)) {
      if (response?.data?.warning) {
        store.dialogStore.openErrorModal(response?.data?.warning)
      } else {
        const text = response?.data?.error_message || response?.data?.message
        store.dialogStore.openErrorModal({ text })
      }
    }

    if (response.status === 401) {
      AuthStorage.clearTokens()
    }
    return Promise.reject(error)
  },
)

export { clientApi }
